<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-2">
<p class="ded"><em class="italic">To Rob Fletcher, who inspired this centenary tribute, and whose</em> contributions have been inestimable.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002_Dedication.vue?44212916